import { put, delay, takeLatest, select } from "@redux-saga/core/effects";
import { fetchAllUnits, fetchOccupantsByUnitId, fetchUnitByUser, fetchUnitFile } from "../../../Utils/BackendAPICalls";
import { Actions, Types } from "../../Reducer/rootReducer";
import { fetchUnit } from "../../selectors";
import { Unit } from "../../../Types/UnitFeatureTypes";

interface FetchUnitAction {
    payload: {
        id?: string;
        fresh?: boolean;
    };
}

interface FetchUnitByUserAction {
    payload: {
        user_id: number;
    };
}

export function* fetchUnitRequestFunction(action: FetchUnitAction): Generator<any, void, Response> {
    const { id, fresh } = action.payload;
    const currentData: Unit[] = (yield select(fetchUnit)) as unknown as Unit[];
    if (currentData.length !== 0 && !fresh) return;
    try {
        yield delay(100);
        const response: any = yield fetchAllUnits();
        if (!response || response?.error) {
            yield put(Actions.fetchUnit.unitActions.failure({ message: response.error }));
        }
        yield put(Actions.fetchUnit.unitActions.success({ units: response.units, count: response.count }));
    } catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.fetchUnit.unitActions.failure(error));
    }
}

export function* fetchUnitOccupantsRequestFunction(action: FetchUnitAction): Generator<any, void, Response> {
    const { id } = action.payload;
    try {
        yield delay(100);
        if (!id) {
            throw new Error("Unit ID is required");
        }
        const response: any = yield fetchOccupantsByUnitId(id);
        if (!response || response?.error) {
            yield put(Actions.fetchUnit.unitOccupantsActions.failure({ message: response.error }));
        }
        yield put(Actions.fetchUnit.unitOccupantsActions.success({ occupants: response }));
    }
    catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.fetchUnit.unitActions.failure(error));
    }
}

export function* fetchUnitByUserRequestFunction(action: FetchUnitByUserAction): Generator<any, void, Response> {
    const { user_id } = action.payload;
    try {
        yield delay(100);
        const response: any = yield fetchUnitByUser(user_id);
        if (!response || response?.error) {
            yield put(Actions.fetchUnit.unitByUserActions.failure({ message: response.error }));
        } else {
            yield put(Actions.fetchUnit.unitByUserActions.success({ unit: response }));
        }
    }
    catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.fetchUnit.unitByUserActions.failure(error));
    }
}

export function* fetchUnitFileRequestFunction(action: {payload: {id: number, fromDate: Date, toDate: Date}}): Generator<any, void, Response> {
    const { id, fromDate, toDate } = action.payload;
    try {
        yield delay(100);
        if (!id) {
            throw new Error("Unit ID is required");
        }
        const response: any = yield fetchUnitFile(id, fromDate.toLocaleDateString("en-US"), toDate.toLocaleDateString("en-US"));
        if (!response || response?.error) {
            yield put(Actions.fetchUnit.unitFileActions.failure({ message: response.error }));
        }
        yield put(Actions.fetchUnit.unitFileActions.success({ unitFile: response.unitFile }));
    }
    catch (err) {
        const error = { message: "fatalFailure" };
        yield put(Actions.fetchUnit.unitFileActions.failure(error));
    }
}

export default function* unitSaga() {
    yield takeLatest(Types.FETCH_UNIT_REQUEST, fetchUnitRequestFunction);
    yield takeLatest(Types.FETCH_UNIT_OCCUPANTS_REQUEST, fetchUnitOccupantsRequestFunction);
    yield takeLatest(Types.FETCH_UNIT_BY_USER_REQUEST, fetchUnitByUserRequestFunction)
    yield takeLatest(Types.FETCH_UNIT_FILE_REQUEST, fetchUnitFileRequestFunction);
}
